"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavIcon = exports.Nav = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _constants = require("../../../constants");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Nav = exports.Nav = _styledComponents.default.div.withConfig({
  displayName: "styles__Nav",
  componentId: "sc-1nzjznx-0"
})(["display:flex;flex-direction:row;align-items:center;padding:0 6px;flex-shrink:0;margin-left:auto;"]);
const NavIcon = exports.NavIcon = _styledComponents.default.div.withConfig({
  displayName: "styles__NavIcon",
  componentId: "sc-1nzjznx-1"
})(["cursor:pointer;padding:", ";position:relative;svg{vertical-align:middle;fill:", ";}svg:hover{fill:", ";}", ";", ";"], ({
  theme
}) => theme.AppFrame.header.nav.iconPadding, ({
  theme
}) => theme.colors.appFrame.header.iconNav, ({
  theme
}) => theme.colors.appFrame.header.iconNavHover, ({
  disabled,
  theme
}) => disabled && (0, _styledComponents.css)(["pointer-events:none;svg{fill:", ";}"], theme.colors.appFrame.header.iconNavDisabled), ({
  hasBadge,
  theme
}) => hasBadge && `
    &::before {
      content: '';
      display: block;
      position: absolute;
      right: ${theme.name === _constants.THEMES.mds ? '4px' : '6px'};
      top: ${theme.name === _constants.THEMES.mds ? '-4px' : 0};
      border-radius: 50%;
      background-color: ${theme.colors.appFrame.header.badgeBg};
      width: 6px;
      height: 6px;
    }
  `);